import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, TeardownLogic } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UpdatePhotoComponent } from './components/update-photo/update-photo.component';
import {
  BooleanCons,
  EstatusTypeCard,
  HttpStatus,
  InitialsDr,
  NumberCons,
  RolesString,
  ROUTE_BY_TYPE_PRODUCT,
  RoutePermissions,
  RoutesCons,
  StringConst,
  TypeClients,
  TypeListProduct,
  TypeScreenView,
  typeViewCatalogs,
  Welcome,
  WhoRequestAccordionMenu
} from './constants/const';
import { SpinnerNames } from './constants/spinners';
import { NotificationSavedProductsComponent } from './dialogs/notification-saved-products/notification-saved-products.component';
import { OpenTransactionsBBVAComponent } from './dialogs/open-transactions-bbva/open-transactions-bbva.component';
import {
  BBVAOpenPageData, BBVAOpenTransactionsResponse, BBVAUrls
} from './model/http/bbva.model';
import { CatalogClassification, CatalogFields } from './model/http/catalogs';
import {
  CheckShoppingAndAdviser,
  ClientDoctorModel
} from './model/http/clientDoctorModel';
import { CreditValidation } from './model/http/creditResponse.model';
import { OptionsHome } from './model/http/home.model';
import { CreateBBVAOrder } from './model/http/invoices-Pending';
import { CallPlace, RestoreCart } from './model/http/myActivity.model';
import { ConfirmOrderReq } from './model/http/ordersresume.model';
import {
  IDoctorAdvisers,
  IMyProfile,
  UpdatePhotoInfo
} from './model/http/profile.model';
import { ExtendedKeycloakProfile, IUserInfoRes } from './model/http/security.model';
import { FileSelectedResult } from './model/local/general.model';
import {
  MenuAccordion,
  MenuItem,
  OrdersCounterDetail
} from './model/local/menu-items.model';
import { SpinnerConfig } from './model/local/spinner';
import { AdvisorInformationService } from './services/advisor-information.service';
import { BBVAPaymentsService } from './services/bbvapayments.service';
import { CatalogsService } from './services/catalogs.service';
import { CommonService } from './services/common.service';
import { CreditService } from './services/credit.service';
import { DateOperationService } from './services/date-operation.service';
import { DialogService } from './services/dialog.service';
import { HomeService } from './services/home.service';
import { LocalStorageService } from './services/local-storage.service';
import { LoggerManagerService } from './services/logger-manager.service';
import { MyProfileService } from './services/my-profile.service';
import { ObservableService } from './services/observable.service';
import { ProductCatalogService } from './services/product-catalog.service';
import { PromotionsService } from './services/promotions.service';
import { SecurityService } from './services/security.service';
import { ShoppingCartService } from './services/shopping-cart.service';
import { ThemeSwitcherService } from './services/theme-switcher.service';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/angular';
// tslint:disable-next-line:ban-types
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent
  implements
  OnDestroy,
  OnInit,
  AfterViewChecked,
  AfterViewChecked,
  AfterViewInit {
  title = 'omicron-dxp';
  now = new Date();
  logged: Promise<boolean>;
  subscriptionObs = new Subscription();
  isScreenPhone = false;
  isOpenMenu = false;
  initialsName = StringConst.empty;
  welcome = Welcome;
  userName = StringConst.empty;
  panelOpenState = false;
  totalPieces = 0;
  routes = RoutesCons;
  menuAccordion = new MenuAccordion();
  whoRequestMenu = new MenuItem();
  accordionMenu = WhoRequestAccordionMenu;
  existProfilePhoto = false;
  profilePhoto = StringConst.empty;
  routesPermissions = RoutePermissions;
  isShoppingCartShow = false;
  myHeaderProfile = new IMyProfile();
  typeListProduct = TypeListProduct;
  listClasificationCatalog: CatalogClassification[] = [];
  hideChangeProfilBtn = false;
  isCalledFromMyProfileBtn = false;
  clientAdviser = new ClientDoctorModel();
  isHeaderClient = false;
  isDoctor = false;
  cardCodeShoppingCart = StringConst.empty;
  cartType = NumberCons.zero;
  showBar = BooleanCons.false;
  counters = new OrdersCounterDetail();
  advisors: IDoctorAdvisers[] = [];
  routesString = RoutesCons;
  activeRol = StringConst.empty;
  whatsAppUrl = StringConst.empty;
  @ViewChild('headerClient') headerClient: ElementRef = {} as ElementRef;
  @ViewChild('contentPage') contentPage: ElementRef = {} as ElementRef;
  showAdvisorModal = BooleanCons.false;
  spinnerName = SpinnerNames.principal;
  showAdvisorOmigenomics = BooleanCons.false;
  bbvaPendingTransactions: Array<BBVAOpenPageData> = [];
  roles = RolesString;
  webbinarUrl = StringConst.empty;
  showGeneralSearchModal = false;
  constructor(
    public observableService: ObservableService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private dateOperationService: DateOperationService,
    private themeSwitcher: ThemeSwitcherService,
    private keycloak: KeycloakService,
    public dialog: MatDialog,
    private router: Router,
    private securityService: SecurityService,
    private catalogService: CatalogsService,
    private cdRef: ChangeDetectorRef,
    private shoppingCart: ShoppingCartService,
    private profileService: MyProfileService,
    private advisorInformationService: AdvisorInformationService,
    private titleService: Title,
    private productCatalogService: ProductCatalogService,
    private render: Renderer2,
    private homeService: HomeService,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private logService: LoggerManagerService,
    private creditService: CreditService,
    private bbvaPaymentsService: BBVAPaymentsService,
    private promotionService: PromotionsService,
    private location: Location
  ) {
    this.subscriptionSearchProductByCatalog();
    this.hasPermission();
    this.getUserInfoFrom();
    this.getScreenSize();
    this.logged = this.keycloak.isLoggedIn();
    this.hideChangeProfilBtn = !this.keycloak.isUserInRole(RolesString.advisor);
    this.menuAccordion = new MenuAccordion();
    this.whoRequestMenu = new MenuItem();
    this.listClasificationCatalog = [];
    this.isHeaderClient = false;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.logService.screenView();
        this.commonService.setHasChanges(false);
      }
    });
  }
  ngAfterViewInit(): void {
    this.disableScrollOndIosWhenModalAppears();
  }

  setupTokenRefresh(): void {
    this.keycloak.keycloakEvents$.subscribe({
      next: (event) => {
        if (event.type === KeycloakEventType.OnTokenExpired) {
          this.keycloak.updateToken(20).then().catch(() => this.logout());
        }
      }
    });
  }

  ngOnInit(): void {
    this.setupTokenRefresh();
    this.updateCartWhenAdviserIsLogged();
    this.subscribeObservables();
    this.subscriptionOnlyMenyProfilePhoto();
    this.updateProfilePhotoObservable();
    this.localStorageService.removePaymentCard();
    window.onpageshow = (event: any): void => {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }

  bbvaTransactions(): void {
    this.bbvaPaymentsService
      .transactions(this.localStorageService.getCardCode())
      .subscribe(this.okBbvaTransactions);
  }

  okBbvaTransactions = ({ response }: BBVAOpenTransactionsResponse): void => {
    this.bbvaPendingTransactions = response.map((transaction) => ({
      amount: Number(transaction.amount.toFixed(2)),
      customerName: this.localStorageService.getHeaderInfo().doctorName,
      cardCode: transaction.cardCode,
      callPlace: CallPlace.default,
      default: {
        transactionId: transaction.transactionId,
        cardCode: transaction.cardCode,
        bbvaOrderId: transaction.transactionId.substring(
          transaction.transactionId.length - 12
        ),
      },
      transactionId: transaction.transactionId,
      failureUrl: BBVAUrls[transaction.transactionType]?.failure ?? '',
      successUrl: BBVAUrls[transaction.transactionType]?.success ?? '',
      confirmOrder: new ConfirmOrderReq(),
      isCreateOrder: false,
      payInvoice: new CreateBBVAOrder(),
    }));
  }

  openModalBBVA = () => {
    const config = new MatDialogConfig();
    config.disableClose = BooleanCons.true;
    config.data = this.bbvaPendingTransactions;
    this.bbvaPendingTransactions = [];
    this.dialogService
      .displayDialog(OpenTransactionsBBVAComponent, config)
      .afterClosed()
      .subscribe((transactions) => {
        this.bbvaPendingTransactions = transactions ? [] : config.data;
      });
  }

  subscribeObservables(): void {
    this.addObservablesToSubscription([
      this.observableService.getIsLoading().subscribe((config) => {
        this.showLoading(config);
      }),
      this.observableService
        .getNotificationToComponents()
        .subscribe((res) => (this.isCalledFromMyProfileBtn = res)),
      this.observableService
        .getTotalProducts()
        .subscribe(() => this.calculateCarQuantity()),
      this.observableService
        .getWhoRequestMenu()
        .subscribe((whoRequestMenu) => this.getWhoRequestMenu(whoRequestMenu)),
      this.observableService
        .getUpdateCouterPiecesShoppingCard()
        .subscribe(() =>
          this.getTotalPicesFromService(this.cardCodeShoppingCart)
        ),
      this.observableService
        .getTitle()
        .subscribe((title) => this.successOpenTitle(title)),
      this.observableService
        .getInfoClientAdviser()
        .subscribe((infoClient) => this.successInfoClientAdviser(infoClient)),
      this.observableService
        .getViewInfoClientAdviser()
        .subscribe((view) => this.successViewInfoClientAdviser(view)),
      this.observableService
        .getValidateDoctorInfo()
        .subscribe((route) => this.checkDoctorInfo(route)),
      this.observableService.getShowAdvisorModal().subscribe((show) => {
        this.showAdvisorModal = show;
      }),
      this.observableService
        .getReloadPendingActiveOrdersCounter()
        .subscribe(() => this.getOrdersQuantities()),
    ]);
  }

  addObservablesToSubscription(observablesList: TeardownLogic[]): void {
    this.subscriptionObs.add(...observablesList);
  }

  calculateCarQuantity(): void {
    this.getTotalPicesFromService(this.cardCodeShoppingCart);
  }

  ngAfterViewChecked(): void {
    if (this.bbvaPendingTransactions.length > 0) {
      this.openModalBBVA();
    }
    this.calculateHeader();
    this.cdRef.detectChanges();
  }
  getItemCatalogClassification(queryParams: string): void {
    this.productCatalogService
      .getcatalogClassification(queryParams)
      .subscribe(
        (result) => {
          const resultList = result.response ?? [];
          this.listClasificationCatalog = resultList;
          this.localStorageService.setClasificationCatalog(this.listClasificationCatalog);
        },
        (error: HttpErrorResponse) => {
          this.reportCatalogClassificationError(error);
        }
      );
  }

  private reportCatalogClassificationError(error: HttpErrorResponse): void {
    const status = error?.status ?? HttpStatus.connectionRefused;
    const url = error?.url ?? StringConst.empty;
    const level: 'warning' | 'error' =
      status === HttpStatus.notFound ? 'warning' : 'error';
    const wrappedError = new Error(
      `catalog-classification request failed: ${status} ${url}`
    );
    Sentry.captureException(wrappedError, {
      level,
      tags: { feature: 'catalog-classification', status: String(status) },
      extra: {
        status,
        statusText: error?.statusText,
        url,
        serverError: error?.error,
        originalError: String(error?.message ?? error),
      },
      fingerprint: ['catalog-classification', String(status)],
    });
  }

  showLoading(config: SpinnerConfig): void {
    config.status
      ? this.spinner.show(config.name)
      : this.spinner.hide(config.name);
  }
  getUserInfoFrom(): void {
    this.securityService.getInfoUser().subscribe(
      (result) => {
        this.onSuccessInfoUser(result);
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`user-info request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'error',
            tags: { feature: 'user-info', status: String(error?.status ?? 0) },
            fingerprint: ['user-info', String(error?.status ?? 0)],
          }
        );
      }
    );
  }
  changeTheme(theme: string): void {
    this.themeSwitcher.loadTheme(theme);
  }

  logout(): void {
    Sentry.setUser(null);
    Sentry.setTag('role', null);
    this.localStorageService.clearSession();
    this.keycloak.logout(`${window.location.origin}/${environment.logoutUrl}`);
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(): void {
    this.successScreenSize(window.innerWidth);
    this.setDocHeight(window.innerHeight);
  }
  setDocHeight(heigth: number): void {
    document.documentElement.style.setProperty('--vh', `${heigth / 100}px`);
    document.documentElement.style.setProperty('--vhMax', `${heigth / 100}px`);
  }

  ngOnDestroy(): void {
    this.subscriptionObs.unsubscribe();
    this.keycloak.keycloakEvents$.unsubscribe();
  }

  toggleMenu(): void {
    this.isOpenMenu = !this.isOpenMenu;
  }

  successScreenSize(innerWidth: number): void {
    this.isScreenPhone = innerWidth < 1080;
    this.isOpenMenu = !this.isScreenPhone;
    const typeScreenList = [
      { min: 0, max: 599, typeScreen: TypeScreenView.mobile },
      { min: 600, max: 765, typeScreen: TypeScreenView.tablet },
      { min: 766, max: 100000, typeScreen: TypeScreenView.web },
    ];
    const typeScreen = typeScreenList.find(
      (type) => innerWidth >= type.min && innerWidth <= type.max
    );
    this.observableService.setTypeScreeView(
      typeScreen?.typeScreen ?? TypeScreenView.web
    );
  }

  goToPage(url: string[]): void {
    if (this.isScreenPhone) {
      this.isOpenMenu = false;
    }
    this.refreshAccordionItems();
    this.router.navigate(url);
    this.isCalledFromMyProfileBtn = url[0] === this.routes.myProfile;
  }

  isActive(path: string): boolean {
    return path === this.location.path();
  }

  refreshAccordionItems(): void {
    this.menuAccordion = new MenuAccordion();
  }

  getCatalogs(): void {
    const cardCodeGeneral = this.localStorageService.getCardCodeGeneral();
    this.catalogService.getCatalogs(cardCodeGeneral).subscribe(
      (res) => {
        const catalogs = res.response;
        const labels = catalogs?.filter((catalog) => catalog.fieldId === 2);
        this.localStorageService.setLabelsCatalog(labels ?? []);
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`catalogs request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'warning',
            tags: { feature: 'catalogs', status: String(error?.status ?? 0) },
            fingerprint: ['catalogs', String(error?.status ?? 0)],
          }
        );
      }
    );
  }

  getTotalPicesFromService(cardCodeShoppingCart: string): void {
    this.shoppingCart
      .getTotalPieces(cardCodeShoppingCart, [
        EstatusTypeCard.doctorShopping,
        EstatusTypeCard.savedCart,
      ])
      .subscribe(
        (res) => {
          const response = res.response ?? [];
          this.totalPieces =
            response.find(
              (item) => item.typeCart === EstatusTypeCard.doctorShopping
            )?.pieces ?? 0;
          this.observableService.setShoppingCartNumber(response);
        },
        (error: HttpErrorResponse) => {
          Sentry.captureException(
            new Error(`cart-total-pieces request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
            {
              level: 'warning',
              tags: { feature: 'cart-total-pieces', status: String(error?.status ?? 0) },
              fingerprint: ['cart-total-pieces', String(error?.status ?? 0)],
            }
          );
        }
      );
  }

  getWhoRequestMenu(whoRequestMenu: MenuItem): void {
    this.whoRequestMenu = whoRequestMenu;
  }

  successOpenTitle(title: string): void {
    this.titleService.setTitle(title);
  }
  getProfilePhoto(): void {
    if (this.keycloak.isUserInRole(RolesString.doctor)) {
      const cardCode = this.localStorageService.getCardCode();
      this.profileService.getImagesReceipt(cardCode).subscribe((res) => {
        const images = res.response ?? [];
        if (images.length > 0) {
          const firstImage = res.response[0];
          let profilePictureUrl =
            firstImage.profilePictureUrl ?? StringConst.empty;
          this.existProfilePhoto = profilePictureUrl.length > 0;
          profilePictureUrl = `${profilePictureUrl}?${this.dateOperationService.getTimeStamp()}`;
          this.profilePhoto = this.commonService.calculateTernary(
            this.existProfilePhoto,
            profilePictureUrl,
            StringConst.empty
          );
          this.localStorageService.setProfilePhoto(this.profilePhoto);
        }
      });
    } else {
      const advisorSap =
        this.localStorageService.getAdvisorInformationFromSAP();
      this.existProfilePhoto = this.commonService.validateValidString(
        advisorSap.profilePictureUrl
      );
      const profilePictureUrl = `${advisorSap.profilePictureUrl
        }?${this.dateOperationService.getTimeStamp()}`;
      this.profilePhoto = this.commonService.calculateTernary(
        this.existProfilePhoto,
        profilePictureUrl,
        StringConst.empty
      );
    }
  }
  // Cuando un doctor está logeado se cambia la foto de perfil en menú y mi perfil
  updateProfilePhotoObservable(): void {
    this.subscriptionObs.add(
      this.observableService.getUpdateMenuPhoto().subscribe((photoSelected) => {
        this.setPhoto(photoSelected);
      })
    );
  }

  // CUANDO UN DOCTOR ESTÁ LOGEADO SOLO SE CAMBIA LA FOTO DEL MENÚ QUE CORRESPONDE AL ASESOR
  subscriptionOnlyMenyProfilePhoto(): void {
    this.subscriptionObs.add(
      this.observableService
        .getUpdateOnlyMenuProfilePhoto()
        .subscribe((photoSelected) => {
          this.setPhoto(photoSelected);
        })
    );
  }

  setPhoto(photoSelected: FileSelectedResult): void {
    this.existProfilePhoto = true;
    this.profilePhoto = this.commonService.convertStringToBase64(
      photoSelected.base64 ?? StringConst.empty,
      photoSelected.type
    );
    this.localStorageService.setProfilePhoto(this.profilePhoto);
  }

  hasPermission(): void {
    this.routesPermissions.menu.forEach(
      (routeMenu) =>
      (routeMenu.isShow = routeMenu.roles.some((role) =>
        this.keycloak.isUserInRole(role)
      ))
    );
    this.isShoppingCartShow = this.keycloak.isUserInRole(RolesString.doctor);
  }

  getSapDataDoctor(): void {
    const cardCode = this.localStorageService.getCardCode();
    const clientType = this.localStorageService.getClientType();
    this.profileService.getMyHeaderMyProfile(cardCode, clientType).subscribe(
      (res) => {
        this.localStorageService.setHeaderInfo(res.response);
        const result = res.response;
        this.whatsAppUrl = result.customerServiceWhatsappUrl;
        this.userName = `${InitialsDr} ${res.response.doctorName}`;
        this.initialsName = this.commonService.getInitialsName(result.doctorName);
        this.myHeaderProfile = result;
        this.advisors = result.doctorAdvisers.map((advisor) => {
          return {
            ...Object.assign(new IDoctorAdvisers(), advisor),
            initials: this.commonService.getInitialsName(
              `${advisor.name} ${advisor.lastName}`
            ),
          };
        });
        this.observableService.setHeaderProfileDoctor(res.response);
        this.observableService.setInfoIsLoading();
        this.bbvaTransactions();
      },
      (error) => {
        Sentry.captureException(error, {
          tags: { feature: 'doctor-profile' },
        });
      }
    );
    this.showSavedProductsNotification();
  }

  showSavedProductsNotification(): void {
    if (this.localStorageService.getNotificationSavedProducts(true)) {
      const request: RestoreCart = {
        cardCode: this.localStorageService.getCardCode(),
        typecart: EstatusTypeCard.savedCart.toString(),
        clientType: this.localStorageService.getClientType(),
        priceListId: this.localStorageService.getPriceList(),
      };
      this.shoppingCart.restoreCartSaved(request).subscribe((res) => {
        const information = res.response ?? [];
        if (information.length > 0) {
          const config = new MatDialogConfig();
          config.data = information;
          config.autoFocus = false;
          this.dialogService.displayDialog(
            NotificationSavedProductsComponent,
            config
          );
          this.localStorageService.setNotificationSavedProducts(
            BooleanCons.true
          );
        }
      });
    }
  }

  getSapDataAdvisor(): void {
    this.advisorInformationService.getAdvisorInfoFromSAP().subscribe(
      (res) => {
        const result = res.response ?? [];
        if (result.length > 0) {
          const advisorInfo = result[0];
          this.localStorageService.setAdvisorInformationFromSAP(advisorInfo);
          this.getAdvisorCatalogs(advisorInfo.line);
          this.observableService.setAdvisorInfoOk(true);
          this.userName = `${advisorInfo.name} ${advisorInfo.middleName} ${advisorInfo.lastName}`;
          this.initialsName = this.commonService.getInitialsName(
            `${advisorInfo.name} ${advisorInfo.lastName}`
          );
          this.myHeaderProfile.doctorName = advisorInfo.name;
          this.existProfilePhoto = false;
          if (
            this.commonService.validateValidString(result[0].profilePictureUrl)
          ) {
            this.getProfilePhoto();
          }
        }
        this.observableService.setInfoIsLoading();
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`advisor-sap-data request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'error',
            tags: { feature: 'advisor-sap-data', status: String(error?.status ?? 0) },
            fingerprint: ['advisor-sap-data', String(error?.status ?? 0)],
          }
        );
      }
    );
  }

  getAdvisorCatalogs(line: string): void {
    this.advisorInformationService.getAdvisorCatalogs(line).subscribe(
      (res) => {
        const resultList = res.response ?? [];
        this.listClasificationCatalog = resultList;
        this.showAdvisorOmigenomics = resultList
          .map((item) => item.catalogName.toUpperCase())
          .includes(this.typeListProduct.Omigenomics.toUpperCase());
        this.localStorageService.setAdvisorClasificationCatalog(this.listClasificationCatalog);
        this.localStorageService.setClasificationCatalog(this.listClasificationCatalog);
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`advisor-catalogs request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'warning',
            tags: { feature: 'advisor-catalogs', status: String(error?.status ?? 0) },
            fingerprint: ['advisor-catalogs', String(error?.status ?? 0)],
          }
        );
      }
    );
  }
  openUploadPhoto(): void {
    const info = new UpdatePhotoInfo();
    info.existProfilePhoto = this.existProfilePhoto;
    info.myHeaderProfile = this.myHeaderProfile;
    info.myHeaderProfile.doctorInitials = this.initialsName;
    info.profilePhoto = this.profilePhoto;
    info.callPlace = CallPlace.components;
    info.changeBoth = this.isCalledFromMyProfileBtn;
    info.cardCode = this.localStorageService.getCardCode();
    info.changePhoto = BooleanCons.true;
    info.isDoctorSelected = this.keycloak.isUserInRole(RolesString.doctor);
    const config = new MatDialogConfig();
    config.width = '300px';
    config.height = '300px';
    config.data = info;
    this.dialogService.displayDialog(UpdatePhotoComponent, config);
  }

  onSuccessInfoUser(result: IUserInfoRes): void {
    this.localStorageService.setCardCode(result.cardcode); // doctor, asesor, reporter
    this.observableService.setCardCodeOk(true);
    this.logService.configId(result.cardcode);
    this.commonService.setUserInfo({
      cardcode: result.cardcode,
      email: result.email,
      emailVerified: result.email_verified,
      familyName: result.family_name,
      givenName: result.given_name,
      locale: result.locale,
      name: result.name,
      preferredUsername: result.preferred_username,
      sub: result.sub,
      advisorId: result.advisorId,
    });
    /** obtener el rol y guardarlo en el local storage */
    const roles = Object.values(RolesString);
    const rol = roles.find((rolIndex) => this.keycloak.isUserInRole(rolIndex)) ?? StringConst.empty;
    this.localStorageService.setUserInRole(rol);
    this.activeRol = rol;

    Sentry.setUser({
      id: String(result.cardcode || result.sub || ''),
      username: result.preferred_username || result.name || result.email || '',
      email: result.email || undefined,
    });
    Sentry.setTag('role', String(rol || 'unknown'));

    this.observableService.setInfoIsLoading();

    if (rol === RolesString.doctor) {
      this.processInfoRolDoctor(result);
    } else if (rol === RolesString.advisor) {
      this.processInfoRolAdviser();
    } else if (rol === RolesString.reporter) {
      this.processInfoReporterRol(result);
      this.observableService.setInfoIsLoading();
    } else if (rol === RolesString.adminPromo) {
      this.processInfoAdminPromoRol(result);
      this.observableService.setInfoIsLoading();
    }
    this.commonService.buildDictionaries();
  }
  getOrdersQuantities(): void {
    const cardCode: string[] = [];
    cardCode.push(this.localStorageService.getCardCodeGeneral());
    this.homeService.getOrdersQuantity(cardCode).subscribe(
      (res) => {
        if (res.response.length > 0) {
          this.localStorageService.setOrdersQuantity(
            res.response[0].ordersCounterDetail
          );
          this.counters = res.response[0].ordersCounterDetail;
          this.observableService.setInfoIsLoading();
        }
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`orders-quantity request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'warning',
            tags: { feature: 'orders-quantity', status: String(error?.status ?? 0) },
            fingerprint: ['orders-quantity', String(error?.status ?? 0)],
          }
        );
      }
    );
  }
  processInfoReporterRol(result: IUserInfoRes): void {
    const userName = this.commonService.getUserInfo().email;
    this.userName = `${result.name}`;
    this.getDinamicParams();
    this.profileService.getReporterPhotoProfile(userName).subscribe((photo) => {
      const image = photo.response.profilePictureUrl;
      this.existProfilePhoto = this.commonService.validateValidString(image);
      this.profilePhoto = this.commonService.calculateTernary(
        this.existProfilePhoto,
        `${image}?${this.dateOperationService.getTimeStamp()}`,
        StringConst.empty
      );
      this.initialsName = this.commonService.getInitialsName(result.name);
    });
  }

  processInfoAdminPromoRol(result: IUserInfoRes): void {
    const userName = this.commonService.getUserInfo().email;
    this.userName = `${result.name}`;
    this.initialsName = this.commonService.getInitialsName(result.name);
    this.profileService.getPromotionsPhotoProfile(userName).subscribe((photo) => {
      const image = photo.response.profilePictureUrl;
      this.existProfilePhoto = this.commonService.validateValidString(image);
      this.profilePhoto = this.commonService.calculateTernary(
        this.existProfilePhoto,
        `${image}?${this.dateOperationService.getTimeStamp()}`,
        StringConst.empty
      );
      this.menuAccordion.accordionCodePromoExpandex = true;
      setTimeout(() => {
        this.menuAccordion.codePromo = false;
      }, 10);
    });
  }

  processInfoRolAdviser(): void {
    this.isDoctor = false;
    this.cartType = EstatusTypeCard.advisorShopping;
    this.getDinamicParams();
    this.getSapDataAdvisor();
    this.getMinPiecesQuantity();
    /** obtener la informacion cliente (doctor) del asesor */
    this.clientAdviser = this.localStorageService.getClientDoctor();
    if (this.clientAdviser.cardCode !== StringConst.empty) {
      this.successInfoClientAdviser(this.clientAdviser);
    } else {
      this.cardCodeShoppingCart = StringConst.empty;
    }
    /** asignar el card codo del  cliente (doctor) del asesor */
    this.localStorageService.setCardCodeGeneral(this.cardCodeShoppingCart);
  }

  processInfoRolDoctor(result: IUserInfoRes): void {
    this.getDinamicParams();
    this.getProfilePhoto();
    this.getMinPiecesQuantity();
    this.cardCodeShoppingCart = result.cardcode;
    this.cartType = EstatusTypeCard.doctorShopping;
    this.getTotalPicesFromService(this.cardCodeShoppingCart);
    this.localStorageService.setCardCodeGeneral(result.cardcode);
    this.getLimitDaysOfCredit(result.cardcode);
    this.isDoctor = true;
    this.getHomeInfo();
    this.getCatalogs();
    this.getPromotionsPending();
    this.observableService.setReloadPendingActiveOrdersCounter();
    this.keycloak.loadUserProfile().then((response) => {

      const priceList = (response as ExtendedKeycloakProfile).attributes?.pricelistid;
      this.savePriceListKeycloak(priceList);
      const typeClient = (response as ExtendedKeycloakProfile).attributes?.type;
      this.saveTypeClienKeycloak(typeClient);
      const clientType = this.localStorageService.getClientType();
      const params = `${result.cardcode}&priceListId=${this.localStorageService.getPriceList()}&skip=true&clientType=${clientType}`;
      this.getItemCatalogClassification(params);
      this.getSapDataDoctor();
    });
  }

  savePriceListKeycloak(priceList?: string): void {
    this.localStorageService.setPriceList(priceList ? priceList : '1');
  }

  saveTypeClienKeycloak(clientType?: string): void {
    this.localStorageService.setClientType(clientType ? clientType : TypeClients.general);
  }

  getHomeInfo(): void {
    this.homeService.getOptionHome(this.activeRol).subscribe((res) => {
      this.localStorageService.setHomeImages(res.response ?? new OptionsHome());
      this.observableService.setInfoIsLoading();
    });
  }

  successInfoClientAdviser(infoClient: ClientDoctorModel): void {
    if (this.keycloak.isUserInRole(RolesString.advisor)) {
      this.localStorageService.setClientDoctor(infoClient);
      this.localStorageService.setPriceList(infoClient.priceList);
      this.localStorageService.setClientType(infoClient.clientType);
      this.clientAdviser = infoClient;
      this.cardCodeShoppingCart = infoClient.cardCode;
      this.localStorageService.setCardCodeGeneral(this.cardCodeShoppingCart);
      this.isShoppingCartShow = this.commonService.validateValidString(
        this.cardCodeShoppingCart
      );
      this.getCatalogs();
    }
  }
  successViewInfoClientAdviser(view: CheckShoppingAndAdviser): void {
    const dictViewCard: { [key: string]: CheckShoppingAndAdviser } = {
      doctor: { isShoppingCartShow: true, isHeaderClient: false },
      advisor: {
        isShoppingCartShow: view.isShoppingCartShow,
        isHeaderClient: view.isHeaderClient,
      },
    };
    const rol = this.localStorageService.getUserInRole();
    const dictViewCardLogin: { [key: number]: CheckShoppingAndAdviser } = {
      0: {
        isShoppingCartShow: view.isShoppingCartShow,
        isHeaderClient: view.isHeaderClient,
      },
      1: { isShoppingCartShow: true, isHeaderClient: false },
    };
    const selectedData =
      dictViewCard[rol] ?? dictViewCardLogin[Number(this.isShoppingCartShow)];
    this.isShoppingCartShow = selectedData.isShoppingCartShow;
    this.isHeaderClient = selectedData.isHeaderClient;
  }
  checkDoctorInfo(routeCons: string): void {
    if (
      this.localStorageService.getClientDoctor().cardCode === StringConst.empty
    ) {
      this.router.navigate([routeCons]);
    }
  }

  updateCartWhenAdviserIsLogged(): void {
    this.subscriptionObs.add(
      this.observableService.getUpdateShoppingCart().subscribe((cart) => {
        if (cart.cardCode !== StringConst.empty) {
          this.getTotalPicesFromService(cart.cardCode);
        }
      })
    );
  }

  calculateHeader(): void {
    if (
      this.commonService.validateSameValues([
        { firstValue: this.headerClient, secondValue: true },
        { firstValue: this.isHeaderClient, secondValue: true },
      ])
    ) {
      const contentHeight = `calc(100% - ${this.headerClient.nativeElement.offsetHeight}px)`;
      this.render.setStyle(
        this.contentPage.nativeElement,
        'height',
        contentHeight
      );
    } else {
      const contentHeight = `100%`;
      this.render.setStyle(
        this.contentPage.nativeElement,
        'height',
        contentHeight
      );
    }
  }

  subscriptionSearchProductByCatalog(): void {
    this.observableService.getSearchProductByCatalog().subscribe((data) => {
      if (data) {
        const route = ROUTE_BY_TYPE_PRODUCT[data.group.toLowerCase()];
        if (route !== StringConst.empty) {
          this.router.navigate([
            ROUTE_BY_TYPE_PRODUCT[data.group.toLowerCase()],
            data.product,
          ]);
        }
      }
    });
  }

  goTo(url: string): void {
    this.router.navigate([url]);
  }

  openPage(url: string): void {
    this.commonService.openNewTapByUrl(url);
  }

  disableScrollOndIosWhenModalAppears(): void {
    this.dialog.afterOpened.subscribe(() => {
      document.body.style.overflow = 'hidden';
    });

    this.dialog.afterAllClosed.subscribe(() => {
      document.body.style.overflow = '';
    });
  }

  getDinamicParams(): void {
    this.catalogService.getDinamicParams().subscribe(
      (res) => {
        if (res.response.length > 0) {
          this.localStorageService.setDinamicParams(res.response);
          this.webbinarUrl = this.commonService.findParamsValue(CatalogFields.webinar);
        }
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`dynamic-params request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'warning',
            tags: { feature: 'dynamic-params', status: String(error?.status ?? 0) },
            fingerprint: ['dynamic-params', String(error?.status ?? 0)],
          }
        );
      }
    );
  }

  getLimitDaysOfCredit(carCode: string): void {
    this.creditService
      .validCredit(carCode, BooleanCons.false, NumberCons.zero)
      .subscribe(
        (res) => {
          const response = res.response ?? new CreditValidation();
          this.localStorageService.setLimitDaysOfCredit(response);
        },
        (error: HttpErrorResponse) => {
          Sentry.captureException(
            new Error(`credit-validation request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
            {
              level: 'warning',
              tags: { feature: 'credit-validation', status: String(error?.status ?? 0) },
              fingerprint: ['credit-validation', String(error?.status ?? 0)],
            }
          );
        }
      );
  }

  getMinPiecesQuantity(): void {
    this.catalogService.getMinPiecesQuantity().subscribe(
      (res) => {
        const response = res.response ?? [];
        const pieces = Number(response.find(item => item.field === CatalogFields.minPiecesQuantity)?.value ?? NumberCons.zero);
        this.localStorageService.setMinPiecesQuantity(pieces);
      },
      (error: HttpErrorResponse) => {
        Sentry.captureException(
          new Error(`min-pieces-quantity request failed: ${error?.status ?? 0} ${error?.url ?? ''}`),
          {
            level: 'warning',
            tags: { feature: 'min-pieces-quantity', status: String(error?.status ?? 0) },
            fingerprint: ['min-pieces-quantity', String(error?.status ?? 0)],
          }
        );
      }
    );
  }

  getRequest(): string {
    const cardCode = this.localStorageService.getCardCodeGeneral();
    const specialty = this.localStorageService.getHeaderInfo().groupName;
    const date = new Date();
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const today = dd + '/' + mm + '/' + yyyy;
    return `?cardCode=${cardCode}&specialityDoctor=${specialty}&dayToLook=${today}`;
  }

  getPromotionsPending(): void {
    this.promotionService.getPendingPromotions(this.getRequest()).subscribe(res => {
      this.observableService.setPendingPromotions(res.response.pendingPromotions);
    });
  }
}
